import styled from "styled-components";

import { pageRoot } from "../../../styles/pageRoot";
import { md3CardRadius } from "../../../shared/styles/md3Components";

export const Container = styled.div`
  ${pageRoot}
  background: ${({ theme }) => theme.colors.layoutBg};
`;

export const Main = styled.main`
  flex: 1;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 3.2rem 1.2rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  @media (min-width: 900px) {
    padding: 4rem 0 5rem;
  }

  .search {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    background: ${({ theme }) => theme.colors.card};
    border-radius: ${({ theme }) => md3CardRadius(theme)}px;
    padding: 1.6rem 2rem;
    box-shadow: ${({ theme }) => theme.shadows.md3Level2};
    border: 1px solid ${({ theme }) => theme.colors.border};
  }

  .boxList {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 1.6rem;
    padding-bottom: 3.2rem;

    .ant-card {
      border-radius: ${({ theme }) => md3CardRadius(theme)}px;
      border: 1px solid ${({ theme }) => theme.colors.border};
      box-shadow: ${({ theme }) => theme.shadows.md3Level1};
      background: ${({ theme }) => theme.colors.card};
      overflow: hidden;
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: translateY(-3px);
        box-shadow: ${({ theme }) => theme.shadows.md3Level2};
      }

      img {
        width: 100%;
        height: 160px;
        object-fit: cover;
      }
    }
  }
`;
